import styled from 'styled-components';


export const NonprofitsFavorite = styled.div`

`;

export const FavoriteNonprofitsSection = styled.div`
    display:flex;
    gap:24px;
     @media screen and (max-width:991px) {
       flex-wrap: wrap;
    }
    @media screen and (max-width:575px) {
       flex-wrap: wrap;
      justify-content: center;
    }
`;


export const FavoriteNonprofitsProfile = styled.div`
  width:100%;
  max-width:282px;
  
`;

export const FavoriteNonprofitsRight = styled.div`
width:100%;
max-width:894px;
  .donate-now-btn.search-donate.btn.btn-primary{
     background:#FFD495;
     &:hover{
        background:#01606F !important;
        color:#fff !important;
      }
    } 
     
`;


export const FavoriteNonprofitsTitle = styled.h1`
    color: #01606F;
    font-family: "Jost", sans-serif;
    font-size:40px;
    font-weight: bold;
    line-height: 58px;
    margin-bottom: 30px;     
@media screen and (max-width:1199px) {
      font-size: 35px;
      line-height: 40px;
  }
  @media screen and (max-width:991px) {
      font-size: 30px;
      line-height: 35px;
  }
  @media screen and (max-width:575px) {
      font-size: 28px;
      line-height: 40px;
      margin-bottom: 20px;
  }


`;
